import type { TenantConfig } from '@/types/TenantConfig'

export const fairgrounds: TenantConfig = {
  logo: 'assets/fairgrounds/static/logo.png',

  // Override the filename to bust caches.

  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    checkoutRoute: {
      stripeWallets: true,
    },
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        title: '<span>Done!</span>',
      },
      eventListingItem: {
        buttonText: 'Buy',
      },
    },
  },
}
